<template>
  <div class="flex-grow-1 d-flex">
    <AgrFeedbackPopup
      v-if="!isUtilisateurAgrial && !$vuetify.breakpoint.smAndDown"
      v-model="openFeedbackPopup"
      :front-version="appVersion"
      :show-popup="true"
      class="avis"
    />
    <AgrNavigation
      v-if="!$vuetify.breakpoint.smAndDown"
      v-model="navigationDrawer"
      :app-version="appVersion"
      :items="menuItems"
      :mini="true"
      :width="330"
      close-on-select
      color="secondary"
    >
      <template
        v-if="isDisplayNouveaute"
        v-slot:[`item.analyse.append`]
      >
        <v-chip
          label
          small
          color="#DBBD00"
        >
          <span class="texte white--text">Nouveau</span>
        </v-chip>
      </template>
    </AgrNavigation>
    <AgrHeader
      :v-model="$vuetify.breakpoint.smAndDown ? null :navigationDrawer"
    >
      <template
        v-if="!loading.init && ((isUtilisateurAgrial && numtiersSelected!= null) || !isUtilisateurAgrial)"
        v-slot:content
      >
        <span v-if="!$vuetify.breakpoint.mobile">
          <v-chip
            v-if="abonnements.culturialAbonne"
            color="var(--kaki)"
            label
            @click="onAbonnementClick"
          >
            <span
              class="action primary--text"
            >
              Abonné
              <v-icon
                class="primary--text"
              >
                mdi-chevron-right
              </v-icon>
            </span>
          </v-chip>
          <v-chip
            v-else
            color="#FDEEE3"
            label
            @click="onAbonnementClick"
          >
            <span class="action --text-orange-dark">
              Non abonné
              <v-icon
                class="--text-orange-dark"
              >
                mdi-chevron-right
              </v-icon>
            </span>
          </v-chip>
        </span>
      </template>
      <template
        v-if="$roles.hasAccessRechercheAdherent()"
        #extension
      >
        <v-row
          :class="$vuetify.breakpoint.mobile ? 'justify-space-between' : 'justify-end'"
          class="header-action"
          no-gutters
        >
          <v-col
            v-if="$roles.hasAccessRechercheAdherent()"
            :cols="$vuetify.breakpoint.smAndDown ? '7' : 'auto'"
            align-self="center"
            class="align-center"
          >
            <v-btn
              v-if="isOnCompteAdherent"
              class="btn-recherche"
              plain
              @click="onLogoutAdherent"
            >
              <span
                :class="$vuetify.breakpoint.mobile ? 'mention' : 'action'"
                class="primary--text"
              >Se déconnecter de l'adhérent</span>
              <v-icon color="primary">
                mdi-power
              </v-icon>
            </v-btn>
            <v-tooltip
              v-else
              bottom
            >
              <template v-slot:activator="{ on }">
                <div v-on="on">
                  <v-btn
                    :class="!$roles.hasAccessAdminParamApplication() ? 'w-100' : ''"
                    :disabled="isOnPageAdmin"
                    class="btn-recherche pr-2"
                    plain
                    @click="openRechercheAdherent = true"
                  >
                    <span
                      :class="$vuetify.breakpoint.mobile ? 'mention pl-2' : 'action'"
                      class="primary--text pr-2"
                    >Rechercher un adhérent</span>
                    <v-icon
                      color="primary"
                      size="medium"
                    >
                      mdi-magnify
                    </v-icon>
                  </v-btn>
                </div>
              </template>
              {{
                isOnPageAdmin
                  ? 'Retourner sur votre accueil'
                  : 'Rechercher un adhérent'
              }}
            </v-tooltip>
          </v-col>
          <v-col
            v-if="$roles.hasAccessAdminParamApplication() || $roles.hasDroitEcritureAdminDte()"
            :cols="$vuetify.breakpoint.mobile ? '5' : 'auto'"
          >
            <div>
              <BaseSelect
                :is-disabled="numtiersSelected != null"
                :items="agrialActions"
                block
                elevation="0"
                is-action
                label
                libelle-btn="Mes actions"
                size="large"
                @onClick="onActionsClick"
              />
            </div>
          </v-col>
        </v-row>
      </template>
      <template v-slot:logo>
        <img
          alt="Logo Culturial"
          class="ml-2 logo-culturial"
          src="@/assets/logo_culturial.png"
        >
      </template>

      <template v-slot:actions>
        <div class="d-flex">
          <AccesRapide
            :abonnements="abonnements"
            :is-non-agr="isNonAgr"
            class="pr-5"
          />
          <BaseSelectUser
            :is-adherent-or-adherent-selected="!isUtilisateurAgrial || (isUtilisateurAgrial && numtiersSelected != null)"
            :is-parametres-exploitation-complet="isParametresExploitationComplet"
            :items="compteActions"
            :libelle-btn="user"
            class="pr-5"
            icon="mdi-account"
            @onClick="toCompteOrDeconnexion"
          />
        </div>
      </template>
    </AgrHeader>
    <v-bottom-navigation
      v-if="$vuetify.breakpoint.smAndDown && ((isUtilisateurAgrial && numtiersSelected!= null) || !isUtilisateurAgrial)"
      active
      class="bottom-nav"
      color="secondary"
      grow
    >
      <v-btn
        :to="{ name: 'main.tableau-de-bord' }"
        class="white"
      >
        <span
          class="action-small font-menu-mobile"
        >Accueil</span>
        <v-icon>
          mdi-home
        </v-icon>
      </v-btn>
      <v-btn
        v-if="numtiers"
        :to="{ name: 'main.mes-contrats' }"
        class="white"
      >
        <span class="action font-menu-mobile">Contrats</span>
        <v-icon>mdi-file-document-edit</v-icon>
      </v-btn>
      <v-btn
        v-if="numtiers"
        :to="{ name: 'main.mes-recoltes' }"
        class="white"
      >
        <span class="action font-menu-mobile">Apports</span>
        <v-icon> mdi-seed-outline </v-icon>
      </v-btn>

      <v-btn
        v-if="numtiers"
        :to="{ name: 'main.mes-cultures' }"
        class="white"
      >
        <span class="action font-menu-mobile">Cultures</span>
        <v-icon> mdi-sprout </v-icon>
      </v-btn>
      <v-btn
        v-if="numtiers && ((codeGraineSelected != null && surfaceTotaleGraineSelected > 0) || (codeGraineSelected == null && culturesSelected.length) || $route.name === 'main.saisie-contrats-adherent')"
        :to="{ name: 'main.mes-outils-d-analyse' }"
        class="white"
      >
        <div class="d-flex">
          <div class="d-flex flex-column">
            <v-icon> mdi-finance </v-icon>
            <span class="action font-menu-mobile">Analyse</span>
          </div>
          <v-icon
            v-if="isDisplayNouveaute"
            color="#DBBD00"
            size="20"
            class="position-icon-new"
          >
            mdi-star-circle
          </v-icon>
        </div>
      </v-btn>
      <v-btn
        v-else
        class="white"
        @click="isOpenModaleInfosManquantes=true"
      >
        <div class="d-flex">
          <div class="d-flex flex-column">
            <v-icon> mdi-finance </v-icon>
            <span class="action font-menu-mobile">Analyse</span>
          </div>
          <v-icon
            v-if="isDisplayNouveaute"
            color="#DBBD00"
            size="20"
            class="position-icon-new"
          >
            mdi-star-circle
          </v-icon>
        </div>
      </v-btn>
    </v-bottom-navigation>
    <v-main
      class="background"
      :class="backgroundColor"
    >
      <span
        v-if="!loading.init && $vuetify.breakpoint.mobile && ((isUtilisateurAgrial && numtiersSelected!= null) || !isUtilisateurAgrial)"
      >
        <v-btn
          v-if="abonnements.culturialAbonne"
          block
          color="white"
          elevation="0"
          tile
          @click="onAbonnementClick"
        >
          <span
            class="action primary--text"
          >
            Abonné
            <v-icon
              class="primary--text"
            >
              mdi-chevron-right
            </v-icon>
          </span>
        </v-btn>
        <v-btn
          v-else
          block
          color="white"
          elevation="0"
          tile
          @click="onAbonnementClick"
        >
          <div class="action --text-orange-dark">
            Non abonné
            <v-icon
              class="--text-orange-dark"
            >
              mdi-chevron-right
            </v-icon>
          </div>
        </v-btn>
      </span>
      <v-container
        fluid
      >
        <div>
          <FilAriane
            :is-non-agr="isNonAgr"
            :is-utilisateur-agrial="isUtilisateurAgrial"
          />
        </div>
        <router-view
          :loading-init="loading.init"
          :numtiers-selected="numtiersSelected"
        />
      </v-container>
      <v-btn
        v-if="
          !isPageFaq
        "
        :to="{ name: 'main.faq' }"
        class="ma-4 btnFaq white"
        elevation="2"
        icon
      >
        <v-badge
          v-if="countNouveaute > 0"
          :content="countNouveaute"
          color="red"
          text-color="white"
        >
          <v-icon
            color="primary"
            large
          >
            mdi-frequently-asked-questions
          </v-icon>
        </v-badge>
        <v-icon
          v-else
          color="primary"
          large
        >
          mdi-frequently-asked-questions
        </v-icon>
      </v-btn>
    </v-main>
    <AgrFooter
      v-if="!isUtilisateurAgrial"
      :class="this.$vuetify.breakpoint.smAndDown ? 'mb-14' : ''"
      :items="footerItems"
    />
    <v-dialog
      v-model="openModaleConfirmation"
      persistent
      width="500"
    >
      <ConfirmModal
        cancel-text="Non"
        confirm-text="Oui"
        title="Confirmation"
        @cancel="openModaleConfirmation=false"
        @confirm="confirmLogout"
      >
        Souhaitez-vous vraiment vous déconnecter ?
      </ConfirmModal>
    </v-dialog>
    <InfoModal
      v-if="isOpenModaleInfosManquantes"
      confirm-text="Renseigner les infos"
      titre="Infos manquantes"
      :is-open-modale-infos-manquantes="isOpenModaleInfosManquantes"
      @close="isOpenModaleInfosManquantes = false"
      @confirm="toPageCulture()"
    >
      <CultureManquanteContentModal />
    </InfoModal>
    <RechercheAdherentModal
      v-if="openRechercheAdherent"
      :is-open-modal-recherche-adherent="openRechercheAdherent"
      titre="Rechercher un adhérent"
      @close="openRechercheAdherent = false"
    >
      <template v-slot:baseCardHelpContent>
        <div class="texte pa-4">
          <RechercheAdherent
            :intro="true"
            @onCloseRecherche="rechercheActive"
          />
        </div>
      </template>
    </RechercheAdherentModal>
    <v-dialog
      v-model="isOpenModalFormulaireParametres"
      persistent
      :fullscreen="$vuetify.breakpoint.mobile"
      :width="$vuetify.breakpoint.mobile ? '400' : '800'"
    >
      <ParametresExploitationModal
        :mise-a-jour="isMiseAJourParametresRequise"
        @close="closeModalFormulaireParametres"
      />
    </v-dialog>
    <v-snackbar
      v-if="displayToastValid"
      v-model="displayToastValid"
      top
      class="top-snackbar"
      :right="!$vuetify.breakpoint.mobile"
      timeout="4000"
      color="green"
    >
      <div class="d-flex">
        <v-icon
          color="white"
          class="mr-3"
        >
          mdi-information
        </v-icon>
        <div>
          <div class="action white--text">
            Enregistré.
          </div>
          <div class="action white--text">
            Vous pouvez modifier vos données dans Mon compte.
          </div>
        </div>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { sortBy, sum } from 'lodash'
import { isBefore } from 'date-fns'
import ConfirmModal from '@/components/modal/confirm-modal.vue'
import InfoModal from '@/components/modal/info-modal.vue'
import {AgrFeedbackPopup, AgrFooter, AgrHeader, AgrNavigation} from '@agrial/ui'
import BaseSelectUser from '@/components/common/base-select-user'
import BaseSelect from '@/components/common/base-select.vue'
import store from '@/store'
import FilAriane from '@/components/nav/fil-ariane.vue'
import RechercheAdherent from '@/views/main/components/recherche-adherent.vue'
import AccesRapide from './components/acces-rapide.vue'
import ParametresExploitationModal from '@/views/compte/components/modal/parametres-exploitation-modal.vue'
import { necessiteMiseAJour } from '@/utils/parametres-exploitation'
import CultureManquanteContentModal from '@/views/cultures/components/modal/culture-manquante-content-modal.vue'
import RechercheAdherentModal from './components/modal/recherche-adherent-modal.vue'

export default {
  name: 'Main',
  beforeRouteEnter (to, from, next) {
    Promise.all([
      store.dispatch('application/fetchAnneeRecolteEnCours'),
      store.dispatch('application/fetchCategoriesContrats'),
      store.dispatch('application/fetchGrainesRs3'),
      store.dispatch('application/fetchArborescenceTypeCulture')
    ])
      .then(() => next())
  },
  components: { AgrNavigation, BaseSelect, ConfirmModal, InfoModal, CultureManquanteContentModal, AgrHeader, AgrFooter, AgrFeedbackPopup, RechercheAdherent, FilAriane, BaseSelectUser, AccesRapide, ParametresExploitationModal, RechercheAdherentModal },
  data () {
    return {
      loading: {
        abonnement: false,
        /*
         * Vrai des le depart : les listes du store sont vides avant le
         * premier appel, et une carte "decouverte" conditionnee a une liste
         * vide s'afficherait le temps du chargement.
         */
        init: true
      },
      menuOpen: false,
      serverError: false,
      openFeedbackPopup: false,
      openModaleConfirmation: false,
      isOpenModaleInfosManquantes: false,
      isOpenModalFormulaireParametres: false,
      isMiseAJourParametresRequise: false,
      displayToastValid: false,
      openRechercheAdherent: false,
      menuItems: [],
      compteActions: [],
      navigationDrawer: true,
      footerItems: [
        {
          label: 'Politique de Cookies',
          // TODO : en attente d'une manière de faire plus propre
          href: 'javascript:Didomi.preferences.show()'
        },
        {
          label: 'Mentions légales',
          route: { name: 'main.mentions-legales' },
        },
        {
          label: 'CGU',
          route: { name: 'main.cgu' }
        },
        {
          label: 'Foire aux questions',
          route: { name: 'main.faq' }
        },
      ],
      backgroundColor: null,
      numtiersSelected: null,
      codeGraineSelected: null,
      anneeRecolteSelected: null
    }
  },
  computed: {
    ...mapGetters({
      anneeRecolteEnCours: 'application/anneeRecolteEnCours',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive',
      avisCampagne: 'application/avisCampagne',
      userProfile: 'user/profil',
      appVersion: 'app/version',
      hasAccessToAdherent: 'user/hasAccessToAdherent',
      adherent: 'adherent/adherent',
      abonnements: 'adherent/abonnements',
      isUtilisateurAgrial: 'user/isUtilisateurAgrial',
      faqThemes: 'faq/faqThemes',
      countNouveaute: 'faq/countNouveaute',
      numtiers: 'adherent/numtiers',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
      parametresExploitation: 'parametresExploitation/parametresExploitation',
      cultures: 'culture/cultures',
      assolement: 'assolement/assolement',
      grainesContractualiseesEtRecoltees:'graine/grainesContractualiseesEtRecoltees'
    }),
    user () {
      return this.adherent.raisonSociale ? this.adherent.raisonSociale : this.userProfile.agrialUserLabel
    },
    isNonAgr () {
      return this.adherent.nonAgr
    },
    isPageFaq () {
      return this.$route.name === 'main.faq'
    },
    isOnPageAdmin () {
      return this.$route.name === 'main.admin.faq'
    },
    isOnPageCompte () {
      return this.$route.name === 'main.compte'
    },
    isOnCompteAdherent () {
      return this.numtiersSelected != null
    },
    agrialActions () {
      const actions = []

      if (this.$roles.hasParamCulturialWriteAccess()) {
        actions.push({ code: 'main.admin.offre-abonnement', libelle: 'Administrer les offres' })
        actions.push({code: 'main.admin.temoignage-abonnement', libelle: 'Ecrire les témoignages'})
        actions.push({code: 'main.admin.rebond', libelle: 'Paramétrer des rebonds'})
        actions.push({code: 'main.admin.faq', libelle: 'Saisir la FAQ'})
      }
      if (this.$roles.hasDroitEcritureAdminDte()) {
        actions.push({ code: 'main.admin.simulateur-repere-eco', libelle: 'Borner le simulateur éco' })
        actions.push({ code: 'main.admin.comparateur-marge', libelle: 'Configurer le comparateur de marge' })
      }
      return sortBy(actions, 'libelle')
    },
    culturesSelected () {
      let grandesCultures = this.cultures.filter(c => c.typeCulture.codeTypeCultureParent === 'GC')
      let result = []
      for (let i = 0; i < grandesCultures.length; i++ ) {
        result.push({ surface: grandesCultures[i].surfaceEnHectare })
      }
      return result
    },
    surfaceTotaleGraineSelected () {
      return sum(this.culturesSelected.flatMap(c => c.surface))
    },
    isDisplayNouveaute () {
      const dateJour = new Date()
      const dateFinNouveaute = new Date(2026, 8, 31)
      return isBefore(dateJour, dateFinNouveaute) 
    }
  },
  watch: {
    numtiersSelected () {
      this.initialize()
    },
    anneeRecolteActive () {
      if (this.anneeRecolteActive != null && this.anneeRecolteActive !== this.anneeRecolteSelected) {
        this.chargeDonneesAdherentAvecAnneeOuGraine()
      }
    },
    codeGraineActive () {
      if (this.codeGraineSelected != null && this.codeGraineActive !== this.codeGraineSelected) {
        this.chargeDonneesAdherentAvecAnneeOuGraine()
      }
    },
    cultures () {
      this.buildMenuAdherent()
    },

    assolement () {
      this.getCultures(this.anneeRecolteSelected)
        .then(() => { this.buildMenuAdherent() })
    },
    $route () {
      this.backgroundColor = this.$route.name === 'main.comparateur-marge-adherent' ? 'white' : '#F1F2F5'
    }
  },
  created () {
    this.backgroundColor = this.$route.name === 'main.comparateur-marge-adherent' ? 'white' : '#F1F2F5'
    this.initialize()
  },
  methods: {
    ...mapActions({
      fetchAnneeRecolteEnCours : 'application/fetchAnneeRecolteEnCours',
      fetchCategoriesContrats : 'application/fetchCategoriesContrats',
      fetchGrainesRs3 :'application/fetchGrainesRs3',
      fetchArborescenceTypeCulture: 'application/fetchArborescenceTypeCulture',
      getAvisCampagne: 'application/getAvisCampagne',
      updateAnneeRecolteActive: 'application/updateAnneeRecolteActive',
      updateCodeGraineActive: 'application/updateCodeGraineActive',
      logout: 'session/logout',
      resetUser: 'user/reset',
      getFaqThemes: 'faq/getFaqThemes',
      fetchAdherent: 'adherent/fetchAdherent',
      fetchAbonnements: 'adherent/fetchAbonnements',
      resetNumtiers: 'adherent/resetNumtiers',
      resetGraines: 'graine/reset',
      fetchRecoltesContractualiseesEtRecoltees: 'recolte/fetchRecoltesContractualiseesEtRecoltees',
      getParametresExploitationComplet: 'parametresExploitation/getParametresExploitationComplet',
      getParametresExploitation: 'parametresExploitation/getParametresExploitation',
      getGrainesContractualiseesEtRecoltees: 'graine/getGrainesContractualiseesEtRecoltees',
      getCultures: 'culture/getCultures',

    }),
    initialize () {
      if (this.numtiersSelected == null) {
        this.numtiersSelected = this.$cookies.get('NUMTIERS_SELECTED')
      }
      this.buildMenuUser()
      this.getFaqThemes()
      if (this.isUtilisateurAgrial) {
        if (this.numtiersSelected != null) {
          // Conseiller sur tdb adhérent
          this.chargeDonneesAdherent()
        } else {
          // Conseiller sur son tdb : aucune donnee adherent a charger.
          this.buildMenuAgrial()
          this.loading.init = false
        }
      } else {
        // Adhérent
        this.chargeDonneesAdherent()
      }
    },
    chargeDonneesAdherent () {
      this.loading.init = true
      this.fetchAdherent(this.numtiersSelected)
        .then(() => {
          Promise.all([
            this.getAvisCampagne(),
            this.getParametresExploitationComplet(),
            /*
             * Les parametres portent la date de derniere modification, sur
             * laquelle repose le rappel bisannuel.
             */
            this.getParametresExploitation().catch(() => null),
            this.fetchAbonnements(this.numtiersSelected),
            this.fetchRecoltesContractualiseesEtRecoltees(this.numtiersSelected)
          ])
            .then(() => {
              if (!this.isUtilisateurAgrial && this.avisCampagne != null && this.avisCampagne.id != null && !this.$vuetify.breakpoint.smAndDown) {
                this.footerItems.push(
                  {
                    label: 'Donner votre avis',
                    callback: this.onOpenFeedbackPopup
                  })
              }
              this.ouvrirModaleParametresSiNecessaire()
              this.chargeDonneesAdherentAvecAnneeOuGraine()
            })
          })
        /*
         * Sans ce garde-fou, un appel en echec laisserait le tableau de bord
         * en chargement indefiniment, puisque l'indicateur demarre a vrai.
         */
        .catch(() => { this.loading.init = false })
    },
    chargeDonneesAdherentAvecAnneeOuGraine () {
      this.anneeRecolteSelected = this.anneeRecolteActive!= null ? this.anneeRecolteActive : this.anneeRecolteEnCours.toString()
      Promise.all([
        this.updateAnneeRecolteActive(this.anneeRecolteSelected),
        this.getCultures(this.anneeRecolteSelected),
        this.getGrainesContractualiseesEtRecoltees(this.anneeRecolteSelected)
      ])
      .then(() => {
        if (this.grainesContractualiseesEtRecoltees.length !== 0) {
          this.codeGraineSelected = this.codeGraineActive != null ? this.codeGraineActive : this.grainesContractualiseesEtRecoltees[0].code
          this.updateCodeGraineActive(this.codeGraineSelected)
        } else {
          this.codeGraineSelected = null
          this.updateCodeGraineActive(null)
        }
        this.buildMenuAdherent()
      })
      .finally(() => { this.loading.init = false })
    },
    buildMenuUser () {
      this.compteActions = []
      if (!this.isUtilisateurAgrial) {
        this.compteActions.push({ libelle: 'Mon compte', code: 'compte' })
        this.compteActions.push({ libelle: 'Se déconnecter', code: 'deconnection' })
      } else {
        if (this.numtiersSelected) {
          this.compteActions.push({ libelle: 'Le compte de l\'adhérent', code: 'compte' })
        } else {
          this.compteActions.push({ libelle: 'Se déconnecter', code: 'deconnection' })
        }
      }
    },
    confirmLogout () {
      this.logout().finally(() => {
        this.resetUser()
        this.$cookies.remove('NUMTIERS_SELECTED')
        this.$cookies.remove('ANNEE_RECOLTE_SAVED')
        this.$cookies.remove('CODE_GRAINE_SAVED')
        this.$router.push({ name: 'login' })
      })
    },
    onOpenFeedbackPopup () {
      this.openFeedbackPopup = true
    },
    onLogoutAdherent () {
      this.updateAnneeRecolteActive(this.anneeRecolteEnCours)
      this.resetNumtiers()
      this.resetGraines()
      this.$cookies.remove('NUMTIERS_SELECTED')
      this.$router.push({ name: 'main.tableau-de-bord' })
      this.fermetureRechercheActive()
    },
    fermetureRechercheActive () {
      this.numtiersSelected = null
      this.openRechercheAdherent = false
      this.compteActions = [{ libelle: 'Se déconnecter', code: 'deconnection' }]
    },
    rechercheActive (tiers) {
      this.numtiersSelected = tiers.numtiers
      this.$cookies.set('NUMTIERS_SELECTED', this.numtiersSelected)
      this.openRechercheAdherent = false
      this.compteActions = [
        { libelle: `Le compte de l'adhérent`, code: 'compte' }
      ]
      this.$router.push({ name: 'main.tableau-de-bord', params: {numtiersSelected: this.numtiersSelected}})
    },
    toCompteOrDeconnexion (value) {
      if (value === 'compte') {
        this.isOpenModaleInfosManquantes = false
        this.$router.push({ name: 'main.compte' })
      } else if (value === 'deconnexionAdherent') {
        this.resetNumtiers()
        this.$router.push({ name: 'main' })
      } else {
        this.openModaleConfirmation = true
      }
    },
    toPageCulture () {
      this.isOpenModaleInfosManquantes = false
      this.$router.push({ name: 'main.mes-cultures' })
      
    },
    buildMenuAgrial () {
      this.menuItems = []
      this.menuItems.push({
        icon: 'mdi-home',
        label: 'Accueil',
        route: { name: 'main' }
      })
    },
    buildMenuAdherent () {
      this.menuItems = []
      if (!this.nonAgr) {
        this.menuItems.push({
          key: 'accueil',
          icon: 'mdi-home',
          label: 'Accueil',
          route: {name:'main.tableau-de-bord'}
        })
      }
      this.menuItems.push({
        key: 'contrat',
        icon: 'mdi-file-document-edit',
        label: 'Mes contrats',
        route: { name: 'main.mes-contrats' }
      })
      this.menuItems.push({
        key: 'apports',
        icon: 'mdi-seed-outline',
        label: 'Mes apports',
        route: { name: 'main.mes-recoltes' }
      })
      this.menuItems.push({
        key: 'culture',
        icon: 'mdi-sprout',
        label: 'Mes cultures',
        route: { name: 'main.mes-cultures' }
      })
      let menuOutilAnalyse = {}
      if ((this.codeGraineSelected != null && this.surfaceTotaleGraineSelected > 0) || (this.codeGraineSelected == null && this.culturesSelected.length) || this.$route.name === 'main.saisie-contrats-adherent') {
        menuOutilAnalyse = {
          key: 'analyse',
          icon: 'mdi-finance',
          label: 'Outils d\'analyse',
          isDisplayNouveaute: this.isDisplayNouveaute,
          route: { name: 'main.mes-outils-d-analyse' }
        }
      } else {
        menuOutilAnalyse = {
          key: 'analyse',
          icon: 'mdi-finance',
          label: 'Outils d\'analyse',
          isDisplayNouveaute: this.isDisplayNouveaute,
          callback: () => this.isOpenModaleInfosManquantes = true
        }
      }
      this.menuItems.push(menuOutilAnalyse)
    },
    onActionsClick (pageCode) {
      this.$router.push({ name: pageCode })
    },
    onAbonnementClick () {
      this.$router.push({ name: 'main.offre-abonnement' })
    },
    closeModalFormulaireParametres (isValid) {
      this.isOpenModalFormulaireParametres = false
      this.isMiseAJourParametresRequise = false
      this.displayToastValid = isValid
    },
    /*
     * Deux cas d'ouverture, dans cet ordre :
     *
     * - parametres jamais renseignes : cas existant, "Non renseigne", que
     *   l'adherent peut passer et qui ne concerne que le tableau de bord ;
     * - parametres renseignes il y a plus de deux ans : rappel de mise a
     *   jour, sur toutes les pages, sans possibilite de passer. Le cookie
     *   d'abandon ne s'y applique pas.
     */
    ouvrirModaleParametresSiNecessaire () {
      if (this.isUtilisateurAgrial) {
        return
      }

      if (!this.isParametresExploitationComplet) {
        this.isMiseAJourParametresRequise = false
        this.isOpenModalFormulaireParametres = this.$route.name === 'main.tableau-de-bord' &&
          this.$cookies.get('HAS_ABANDON_PARAM_MODAL') == null
        return
      }

      this.isMiseAJourParametresRequise = necessiteMiseAJour(this.parametresExploitation)
      this.isOpenModalFormulaireParametres = this.isMiseAJourParametresRequise
    }
  }
}
</script>
<style lang="scss">

.v-app-bar {
  display: flex;
  flex-direction: column-reverse;
}
.v-toolbar__extension {
  padding: 0 !important;
}

.inline {
  display: inline-block;
}

.background {
  margin-bottom: 100px;
}

.logo-culturial {
  width: 8.5rem;
}

.btnFaq {
  width: 64px !important;
  height: 64px !important;
  position: fixed;
  bottom: 9vh;
  right: 0;
  z-index: 4;
}

.no-radius {
  border-radius: 0 !important;
}

.btn-recherche {
  padding: 0 !important;
  font-size:10px !important;
}

.w-100 {
  width: 100%;
}

.header-action {
  border-bottom: 1px solid var(--Gris-clair, #d7d8d6);
}

@media only screen and (min-width: 960px) {

  .background {
    margin-bottom: 0;
  }

  .logo-culturial {
    width: 10.5rem;
  }

  .btnFaq {
    width: 64px !important;
    height: 64px !important;
    position: fixed;
    right: 0;
    bottom: 1vh;
    z-index: 4;
  }
}

.align-center {
  text-align: center;
}

.align-end {
  text-align: end;
}

.item-callback {
  text-decoration: underline;
}
.icon-bag {
  width: 3.5rem;
  margin-left: 12px;
}

.position-icon-new {
 position: absolute;
 right: 15px;
 top: -15px;
}

.bottom-nav {
  position: fixed !important;
  z-index: 4;
}
.font-menu-mobile {
  font-size: 10px !important;
}

a {
  .v-btn__content {
    .font-menu-mobile {
      color: var(--secondary);
    }
  }
}
</style>

<style lang="scss">
.avis::v-deep {
  .feedback {
    z-index: 5;
    bottom: 120px;
  }
}
.v-item-group.v-bottom-navigation .v-btn {
  min-width: 50px !important;
}

.top-snackbar {
  position: absolute !important;
}
</style>
